import gql from 'graphql-tag';

export default gql`
fragment AdminCmsListItem on AdminCmsContent {
    id
    title
    url_key
    is_active
    active_from
    active_to
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/AdminCmsListItem.ts